import { createHighContrastTheme } from '../../utils/createHighContrastTheme';
export const teamsHighContrastTheme = createHighContrastTheme();
